import { ReebeloStoreT } from '@lambda/reebelo';
import getUSContent from './US';
import getAUContent from './AU';
import getCAContent from './CA';
import getSGContent from './SG';
import getNZContent from './NZ';
import getUKContent from './UK';
import { Content } from './types';

export const generateContent = (store: ReebeloStoreT): Content[] => {
  switch (store) {
    case 'reebelo-us':
      return getUSContent();
    case 'reebelo-uk':
      return getUKContent();
    case 'reebelo-au':
      return getAUContent();
    case 'reebelo-ca':
      return getCAContent();
    case 'quista':
      return getSGContent();
    case 'reebelo-nz':
      return getNZContent();
    default:
      return getUSContent();
  }
};
